GameView    = require("views/base/game")
{ DraggyView } = require("views/components/draggy")
container   = require("./components/container")
theAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")

class GameJumbleView extends GameView
  template: require("./template")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    words = _.compact _.map @options.data.words, (m) ->
      if _.isString(m.word) and m.word isnt ""
        # Remove html tags from the words
        m.word = m.word.replace(/<\/?[^>]+(>|$)/g, "")
        m.word = _.unescape m.word
        m
      else
        null

    @setArray words, "words"

  initializeElements: ->
    super
    @setEl @findOne(".game-box"), "container"

  startGame: ->
    @displayMaskedImage()
    @game.timer.timestamp = Date.now()
    draggy.unlock() for draggy in @draggies

    @answeredCount = 0

    super

  showNext: (isFirstRun) ->
    {word, image} = @getRandom("words")
    word          = word.toUpperCase()
    letters       = @getRandomLetters(_.without(word.split(""), " "))
    difficulty    = @getDifficulty()
    remaining     = word.length - 1

    @game.timer.timestamp = Date.now()
    complete =
      while letters.length > difficulty and remaining > 0
        letter = _.sample(letters)
        lettersWithoutFirstLetter =
          _.filter(letters, (l, i, a) -> a.indexOf(letter) isnt i)
        if _.intersection(letters, lettersWithoutFirstLetter).length is 0
          continue
        letters = lettersWithoutFirstLetter
        remaining -= 1
        letter
    while letters.length < Math.min(difficulty + _.random(1, 2), 6)
      letters.push(_.sample(theAlphabet))

    ids =
      for letter in letters
        Math.random().toString(16).slice(2)

    @getEl("container").innerHTML = container
      ids: ids
      word: word
      image: image
      letters: _.shuffle(letters)
      complete: complete

    @setEl(@findAll(".jumble-mask"), "masks")

    @droppies = @getElements(".droppy")

    @draggies =
      for el in @findAll(".draggy")
        draggy = new DraggyView({el})
        @listenTo draggy, "drag", @onDrag
        @listenTo draggy, "drop", @onDrop
        draggy.lock() if isFirstRun
        draggy

    @displayMaskedImage() unless isFirstRun
    @displayLetters()
    @displayDraggies()

    @getEl("container").offsetTop

    @transform @getEl("container"),
      opacity: 1
      transition: "opacity 300ms"

  displayMaskedImage:  ->
    for el, i in _.shuffle(@getEl("masks"))
      @transform el,
        opacity: 0
        transition: "opacity 300ms #{i * (5000 / @getEl("masks").length)}ms"

  displayLetters: ->
    for el in @findAll(".jumble-answer, .jumble-letters")
      for child, i in el.querySelectorAll(".letter")
        @transition child, "all 300ms #{i * 50}ms", true
        child.classList.add "visible"

  displayDraggies: ->
    for draggy in @draggies
      @resetDraggy draggy

  getElements: (selector) ->
    for el in @findAll(selector)
      el: el
      bounds: el.getBoundingClientRect()

  onDrag: (draggy, isInitialDrag) ->
    @droppies    = @getElements(".droppy", @droppies) if isInitialDrag
    activeIndex  = draggy.closest(_.pluck(@droppies, "bounds"))
    activeDroppy = @droppies[activeIndex]

    for droppy, i in @droppies
      droppy.el.classList.toggle("active", i is activeIndex)
      droppy.isActive = i is activeIndex

    draggy.el.classList.toggle("active-pos", activeDroppy?)

    for { el } in @draggies when el isnt draggy.el
      shouldHide = el.dataset.id is activeDroppy?.el.dataset.contains
      el.classList.toggle "hidden", shouldHide

    {x, y} =
      if activeDroppy
        @positionFromBounds(draggy, activeDroppy.bounds)
      else
        draggy

    @transform draggy.el,
      x: x
      y: y
      scale: if activeDroppy then 1 else 1.4
      transition: if isInitialDrag or activeDroppy then "all 300ms" else "none"

    draggy.el.offsetLeft unless isInitialDrag

  onDrop: (draggy) ->
    droppy = _.findWhere @droppies, isActive: true

    if droppy
      {x, y} = @positionFromBounds(draggy, droppy.bounds)

    else
      x = y = 0

    if draggy.x isnt x or draggy.y isnt y
      draggy.reset({x, y})
    else
      @transform draggy.el,
        x: draggy.x
        y: draggy.y
        transition: "all 300ms"

      @updateDroppies(draggy)
      @checkAnswer()

  updateDroppies: (draggy) ->
    for droppy in @droppies
      droppy.el.classList.remove("active")
      containsActive = droppy.el.dataset.contains is draggy.el.dataset.id

      if droppy.isActive
        draggy.el.classList.add("is-positioned")

        if droppy.el.dataset.contains and not containsActive
          droppy.isActive = false
          @resetDraggy @getDraggy(droppy.el.dataset.contains)

        droppy.el.dataset.contains = draggy.el.dataset.id

      else if containsActive
        delete droppy.el.dataset.contains

  positionFromBounds: (draggy, bounds) ->
    {left, top, width, height} = draggy.offset

    x: Math.round bounds.left + bounds.width / 2 - left - width / 2
    y: Math.round bounds.top + bounds.height / 2 - top - height / 2

  resetDraggy: (draggy) ->
    draggy.reset()
    draggy.el.classList.remove("is-positioned", "hidden", "active-pos")
    @transform draggy.el,
      rotate: _.random(-8, 8)
      transition: "all 300ms"

  checkAnswer: ->
    active  = @droppies.filter (droppy) -> droppy.el.dataset.letter
    correct = active.filter (droppy) =>
      draggy = @getDraggy(droppy.el.dataset.contains)
      droppy.el.dataset.letter is draggy?.el.dataset.letter

    if active.length is correct.length
      draggy.undelegateEvents() for draggy in @draggies

      diff = @game.timer.timestamp - Date.now()
      over = 5000 + @getDifficulty() * 500

      @onCorrectAnswer
        score: 1000
        time: 3000
        tally: true

      @el.classList.add("correct")

      @transform @getEl("container"),
        opacity: 0
        transition: "opacity 300ms 900ms"

      window.setTimeout (=>
        for el in @findAll(".letter")
          el.classList.remove "visible"
      ), 300

      window.setTimeout (=>
        @el.classList.remove("correct")

        @answeredCount += 1

        if @game.timer.get("isDisabled") and @answeredCount is @getArray("words").length
          @endGame()
          return
        
        @showNext()
      ), 1200

  getDraggy: (id) ->
    (draggy for draggy in @draggies when draggy.el.dataset.id is id)[0]

  getDifficulty: ->
    Math.floor _.limit(@game.score.get("consecutive") / 1.6, 6, 1)

  getRandomLetters: (word) ->
    _
      .chain(theAlphabet)
      .difference(word)
      .sample(6 - word.length)
      .value()
      .concat(word)

module.exports = GameJumbleView
